// https://vuex.vuejs.org/en/actions.html
import axios from '@/axios'

// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  login ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      // axios.post('/auth', { username: userData.username, password: userData.password })
      axios.post('Usuario/Autenticar', { Usuario: userData.username, Password: userData.password })
        .then(response => {
          if(response.data.resultado===0){
            var datosuser=response.data.datos[0];
            const token = datosuser.token;
            const user = datosuser.usuario;
            const username = datosuser.usuarionombre;
            //const rolesuser = response.data.roles[0].idrol
            const rolesuser = datosuser.roles;
            const rolesuserid= datosuser.idroles;
            const permisos = datosuser.permisos;
            const vencimiento = datosuser.validohasta;
            const foto = datosuser.foto;
            const idestado= datosuser.idestado;
            const idsede= datosuser.idsede;
            const mensaje= response.data.resultadomensaje;
            const idpersona= datosuser.idpersona;
            console.log(response);
            // storing jwt in localStorage. https cookie is safer place to store
            localStorage.setItem('token', token);
            localStorage.setItem('user', user);
            localStorage.setItem('username', username);
            localStorage.setItem('rolesuser', rolesuser);
            localStorage.setItem('rolesuserid', rolesuserid);
            localStorage.setItem('permisos', permisos);
            localStorage.setItem('vencimiento', vencimiento);
            localStorage.setItem('foto', foto);
            localStorage.setItem('idestado', idestado);
            localStorage.setItem('idsede', idsede);
            localStorage.setItem('mensaje', mensaje);
            localStorage.setItem('idpersona',idpersona);

            // var roluser = rolesuserid.split(',');
            // var roles=[];
            // roluser.forEach((elemento) => {
            //     roles.push(parseInt(elemento));
            // });
            var lstrodid= JSON.stringify(rolesuserid);
            localStorage.setItem('rolesid', lstrodid);

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
            // mutation to change state properties to the values passed along
            commit('auth_success', { token, user, username, rolesuser,rolesuserid,lstrodid, vencimiento, foto, idestado,idsede,mensaje,idpersona })
            resolve(response)
          }else{
            localStorage.setItem('mensaje', response.data.resultadomensaje)
            commit('auth_error', response.data.resultadomensaje);
            resolve(response);
          }
        })
        .catch(err => {
          console.log('login error');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('username');
          localStorage.removeItem('rolesuser');
          localStorage.removeItem('rolesuserid');
          localStorage.removeItem('rolesid');
          localStorage.removeItem('permisos');
          localStorage.removeItem('vencimiento');
          localStorage.removeItem('foto');
          localStorage.removeItem('idestado');
          localStorage.removeItem('idsede');
          localStorage.removeItem('idpersona');
          localStorage.setItem('mensaje', err.message);
          commit('auth_error',err.message);
          reject(err);
        })
    })
  },
  logout ({ commit }) {
    // return new Promise((resolve, reject) => {
    return new Promise((resolve) => {
      commit('logout')
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('username');
      localStorage.removeItem('rolesuser');
      localStorage.removeItem('rolesuserid');
      localStorage.removeItem('rolesid');
      localStorage.removeItem('permisos');
      localStorage.removeItem('vencimiento');
      localStorage.removeItem('foto');
      localStorage.removeItem('idestado');
      localStorage.removeItem('idsede');
      localStorage.removeItem('mensaje');
      localStorage.removeItem('idpersona');
      delete axios.defaults.headers.common['Authorization'];
      resolve();
    })
  },
  refreshtoken ({ commit }) {
    axios.get('/refresh')
      .then(response => {
        const token = response.data.access_token
        localStorage.setItem('token', token)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        commit('auth_success', { token })
      })
      .catch(error => {
        console.log('refresh token error')
        commit('logout')
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
        localStorage.removeItem('rolesuser');
        localStorage.removeItem('rolesuserid');
        localStorage.removeItem('rolesid');
        localStorage.removeItem('permisos');
        localStorage.removeItem('vencimiento');
        localStorage.removeItem('foto');
        localStorage.removeItem('idestado');
        localStorage.removeItem('idsede');
        localStorage.removeItem('mensaje');
        localStorage.removeItem('idpersona');
        console.log(error)
      })
  }
  /* getTableList ({ commit }, tableName) {
    this.$http.get(`/${tableName}`)
      .then(response => {
        console.log(response)
        let tableList = response.data.Keys
        commit('setTableList', { tableList })
      })
      .catch(error => console.log(error))
  },
  updateTableItem ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({ url: `/${tableData.endpoint}`, method: httpmethod, data: tableData.tableItem })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  } */

//   autoRefreshToken ({ commit }) {
//     return new Promise((resolve, reject) => {
//       setInterval(function () {
//         // code goes here that will be run every 20 minutes.
//         axios.get('/refresh')
//           .then(response => {
//             const token = response.data.access_token
//             localStorage.setItem('token', token)
//             axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
//             commit('auth_success', { token })
//             resolve(response)
//           })
//           .catch(error => {
//             console.log('refresh token error')
//             console.log(error)
//             reject(error)
//           })
//       }, 120000)
//     }
//     )
//   },

}
